import { render } from "./app-menu-second.vue?vue&type=template&id=7822c0f9&scoped=true"
import script from "./app-menu-second.vue?vue&type=script&lang=js"
export * from "./app-menu-second.vue?vue&type=script&lang=js"

import "./app-menu-second.vue?vue&type=style&index=0&id=7822c0f9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7822c0f9"]])

export default __exports__